import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import HeaderComponent from '../components/header/HeaderComponent';
import { logout } from '../store/actions/session';

const _ = require('lodash');

const mapStateToProps = ({ session, companies: { currentCompany } }, { history, location, isEntryPoint }) => ({
    user: _.isEmpty(session.user) ? null : session.user,
    history,
    location,
    isEntryPoint,
});

const mapDispatchToProps = {
    logout,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderComponent));



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js